class MFRGridWithTagFiltering {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      grid: ".blog-grid__articles",
      loadMore: ".blog-grid__load-more",
      tagFilters: ".blog-grid__tag-filters",
    };

    this.sectionID = this.$element.closest("section").attr("id");
    this.blogURL = this.$element.data("blog-url");
    this.init();
  }

  init() {
    this.$loadMore = this.$element.find(this.selectors.loadMore);
    this.$grid = this.$element.find(this.selectors.grid);
    this.$tagFilters = this.$element.find(this.selectors.tagFilters);

    this.$element.removeClass("loading");

    $(document).on("click", `#${this.sectionID} ${this.selectors.loadMore} a.button`, this.__handleLoadMore.bind(this));
    
    this.$tagFilters
      .find("a")
      .on("click", this.__handleTagFilterClick.bind(this));

    this.checkScrollBar();
    $(window).on("resize", this.checkScrollBar.bind(this));

    this.preselectTag();
  }

  __handleLoadMore(e) {
    e.preventDefault();
    const url = $(e.currentTarget).attr("href");

    this.$element.addClass("loading");

    this.getArticleCards(url).then((res, rej) => {
      this.$grid.find(this.selectors.loadMore).remove();

      if (res.length) {
        this.$grid.append(res.html());
      }

      lozad("img.lozad").observe();
      this.$element.removeClass("loading");
    });
  }

  __handleTagFilterClick(e) {
    e.preventDefault();
    let url;
    if ($(e.currentTarget).hasClass("is-active")) {
      url = this.blogURL;
    } else {
      url = $(e.currentTarget).attr("href");
    }

    this.$element.addClass("loading");

    this.getArticleCards(url).then((res, rej) => {
      this.$grid.find(this.selectors.loadMore).remove();

      if (res && res.length) {
        this.$grid.html(res.html());
      } else {
        this.$grid.html(
          `<h5 class="blog-grid__no-post">There are no articles found.</h5>`
        );
      }

      if (!$(e.currentTarget).hasClass("is-active")) {
        this.$tagFilters.find("a").removeClass("is-active");
        $(e.currentTarget).addClass("is-active");
      } else {
        this.$tagFilters.find("a").removeClass("is-active");
      }
      lozad("img.lozad").observe();
      this.$element.removeClass("loading");
    });
  }

  getArticleCards(pageUrl) {
    return new Promise((res, rej) => {
      $.ajax({
        type: "GET",
        url: pageUrl,
        success: (data) => {
          const grid = $(data).find(this.selectors.grid);
          res(grid);
        },
        error: (data) => {
          res(false);
        },
      });
    });
  }

  checkScrollBar() {
    const hasScrollBar =
      this.$tagFilters.get(0).scrollWidth > this.$tagFilters.get(0).clientWidth;
    if (hasScrollBar) this.$tagFilters.css("justify-content", "flex-start");
    else this.$tagFilters.css("justify-content", "center");
  }

  preselectTag() {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("tag");

    if (myParam && this.$tagFilters.find(`a[data-handle="${myParam}"]`).length)
      this.$tagFilters.find(`a[data-handle="${myParam}"]`).click();
  }
}